import React from 'react';

// TODO: RN Web - Implement widget
const VideoWidget: React.FC = () => {
  return null;
};

export default VideoWidget;
